import React, { useState } from 'react';
import TextInput from 'web/components/form-elements/TextInput';
import { checkIsZipCode } from 'redux/actions/adminPtPlus/index';
import { useHistory } from 'react-router-dom';
import { useDispatch } from "react-redux";
import NumberInput from 'web/components/form-elements/NumberInput';
import AlertModal from "web/components/AlertModal";
import styled from 'styled-components';

const AddressEditForm = ({ props, checkoutPageData }) => {
    const { setFieldValue } = props
    const dispatch = useDispatch();
    let history = useHistory();
    const [isZipValid, setIsZipValid] = useState(true)
    const [modal, setModal] = useState(false);
    const [modalContent, setModalContent] = useState("");
    const [modalLink, setModalLink] = useState("/");
    let title = "";
    const toggleModal = () => setModal(!modal);

    const callFunction = async (value, setFieldValue) => {
        setIsZipValid(true)
        const token = localStorage.getItem('token')
        let response = '';
        if (value.length === 5) {
            response = await dispatch(checkIsZipCode(value, token))
            if (response.success) {
                setFieldValue('brokercity', response?.data?.city)
                setFieldValue('brokerzip', response?.data?.zipCode)
                setFieldValue('brokerstate', response?.data?.state)

            } else {
                if (response?.data?.error?.message === 'Invalid Zip Code.') {
                    setFieldValue('brokercity', "")
                    setFieldValue('brokerstate', "")
                    setIsZipValid(false)
                } else if (response.statusCode === 401) {
                    history.push('/sign-in')
                    window.location.reload(false);
                } else {

                }
            }
        } else {
            setFieldValue('brokercity', "")
            setFieldValue('brokerstate', "")
        }
    }

    return (
        <>
            <AddressWrapper>
                <div className="row" style={{ 'margin-top': '5px' }}>
                    <div className="col-sm-12">
                        <div className="mt-0">
                            <p>Company Name</p>
                        </div>
                        <TextInput
                            name="brokername"
                            placeholder="Enter Name*"
                            showErrorMessages={true}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-6 col-md-6">
                        <div className="mt-0">
                            <p>Address Line 1</p>
                        </div>
                        <TextInput
                            name="brokerline1"
                            placeholder="Street Address 1*"
                            showErrorMessages={true}
                        />
                    </div>
                    <div className="col-sm-6 col-md-6">
                        <div className="mt-0">
                            <p>Address Line 2</p>
                        </div>
                        <TextInput
                            name="brokerline2"
                            placeholder={"Street Address 2"}
                            showErrorMessages={true}
                        />
                    </div>

                </div>
                <div className="row">
                    <div className="col-sm-6 col-md-4">
                        <div className="mt-0">
                            <p>City</p>
                        </div>
                        <TextInput
                            name="brokercity"
                            placeholder="City&#42;"
                        />
                    </div>
                    <div className="col-sm-6 col-md-4">
                        <div className="mt-0">
                            <p>State</p>
                        </div>
                        <TextInput name="brokerstate" disabled={true} />

                    </div>
                    <div className="col-sm-6 col-md-4">
                        <div className="mt-0">
                            <p>Zip</p>
                        </div>
                        <NumberInput
                            name="brokerzip"
                            placeholder="Zip*"
                            maxLength="5"
                            onChangeHandler={(value) => {
                                callFunction(value, setFieldValue)
                            }}
                        />
                        {!isZipValid && <p style={{ fontSize: '12px', color: '#ef5657', marginTop: '-16px' }}>Invalid zip code.</p>}
                    </div>
                </div>
            </AddressWrapper>
            <AlertModal
                isOpen={modal}
                toggle={toggleModal}
                title={title}
                content={modalContent}
                link={modalLink}
            />
        </>
    )
}


export default AddressEditForm;

const AddressWrapper = styled.div`
    border-radius: 10px;
    box-shadow: 0 2px 10px 0 rgb(0 0 0 / 16%);
    padding: 2px 13px 15px 13px;
    .app-input-text{
        margin-bottom: 4px;
    }

    hr {
        margin-top: 5px !important;
        margin-bottom: 19px !important;
    }
    `;

const HeadingWrapper = styled.div`
    position: relative;
    .right-arrow {
        position: absolute;
        left: -33px;
        top: 0;
    }
    .bold-p-tag {
        font-family: 'latobold';
        font-size: 20px;
        color: #000000;
    }
    .normal-p-tag {
        font-family: 'latomedium';
        font-size: 17px;
    }
    display: flex;
    align-items: baseline;
    @media (max-width: 767px) {
        h6 {
        font-size: 20px !important;
        line-height: 36px !important;
        }
        .right-arrow {
        max-width: 71px;
        }
    }
    `;